import { Divider, Grid } from "@material-ui/core";
import {
  InputCheckboxMaster,
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import { isNull } from "App/utils/helpers";
import moment from "moment";
import React from "react";
import { RESET_STATE_FORM_FILTER } from "./helpers";
import DatePicker from "react-datepicker";

function FormFilterPaketTelekonsul({
  formFilter,
  setFormFilter,
  setNewData,
  typeButton = "submit",
}) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };
  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={12} md={4}>
            <InputTextMaster
              type="number"
              name="id"
              label="ID"
              id="id_request"
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder="ID"
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <InputTextMaster
              name="nama_paket"
              label="NAMA"
              id="nama_paket"
              value={formFilter.nama}
              onChange={handleChange("nama")}
              placeholder="NAMA"
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <InputTextMaster
              name="code_paket"
              label="CODE"
              id="code_paket"
              value={formFilter.code}
              onChange={handleChange("code")}
              placeholder="CODE"
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <InputOptionMaster
              name="status_paket"
              label="STATUS"
              id="status_paket"
              withSearch={true}
              data={[
                {
                  value: 1,
                  label: "Aktif",
                },
                {
                  value: 0,
                  label: "Non-Aktif",
                },
              ]}
              value={formFilter?.status}
              labelValue={formFilter?.status_nama}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    status: "",
                    status_nama: "Pilih Status",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    status: e.value,
                    status_nama: e.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={12} md={4}>
            <label htmlFor="date" className="form-control-label">
              TANGGAL AWAL
            </label>
            <DatePicker
              id="date"
              autoComplete="off"
              className="form-control text"
              dateFormat="dd/MM/yyyy"
              timeIntervals={5}
              locale="id-ID"
              selected={moment(formFilter.tanggal_awal).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tanggal_awal: e,
                });
              }}
              placeholderText="Tanggal"
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <label htmlFor="date" className="form-control-label">
              TANGGAL AKHIR
            </label>
            <DatePicker
              id="date"
              autoComplete="off"
              className="form-control text"
              dateFormat="dd/MM/yyyy"
              timeIntervals={5}
              locale="id-ID"
              selected={moment(formFilter.tanggal_akhir).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tanggal_akhir: e,
                });
              }}
              placeholderText="Tanggal"
            />
            <div
              style={{
                cursor: "pointer",
                marginTop: "-3.7rem",
                position: "absolute",
                right: "2.5rem",
              }}
            >
              <InputCheckboxMaster
                checked={formFilter.status_tgl}
                name="status_tgl"
                id="status_tgl"
                label="Dengan Tanggal"
                onChange={() =>
                  setFormFilter({
                    ...formFilter,
                    status_tgl: !formFilter.status_tgl,
                  })
                }
              />
            </div>
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            onClick={handleSubmit}
            type={typeButton}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  );
}

export default FormFilterPaketTelekonsul;
